export default __webpack_public_path__ + "b56b330a445cb3810fe8efd65e66ed0c.png";